import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "../../config/config";
import toast from "react-hot-toast";

export const fetchLuggageRequests = createAsyncThunk(
    "luggage/fetchLuggageRequests",
    async (_, { rejectWithValue }) => {
        try {
            const response = await API.GET(`/luggage-requests`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const updateLuggageRequestStatus = createAsyncThunk(
    "luggage/updateLuggageRequestStatus",
    async ({ requestId, status }: any, { rejectWithValue }) => {
        try {
            await API.PUT(`/luggage-requests/${requestId}`, { status });
            toast.success("Luggage request status updated successfully");
            return { requestId, status };
        } catch (error: any) {
            toast.error("Error updating luggage request status");
            return rejectWithValue(error.response.data);
        }
    }
);

const luggageSlice = createSlice({
    name: "luggage",
    initialState: {
        luggageRequests: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchLuggageRequests.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchLuggageRequests.fulfilled, (state, action) => {
                state.loading = false;
                state.luggageRequests = action.payload;
            })
            .addCase(fetchLuggageRequests.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as any;
            })
            .addCase(updateLuggageRequestStatus.fulfilled, (state, action) => {
                const { requestId, status } = action.payload;
                const request: any = state.luggageRequests.find((req: any) => req._id === requestId);
                if (request.status) request.status = status

            });
    },
});

export default luggageSlice.reducer;
